<template>
	<page>
		<module>
			<div class="order-state flex-between-center">
				<h1>状态：{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>
			
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>采购单号：</label>
							<p>{{orderDetail.order_number}} <a @click="clipboard(orderDetail.order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex">
							<label>平台订单号：</label>
							<p>{{orderDetail.platform_order_number}} <a @click="clipboard(orderDetail.platform_order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex">
							<label>下单时间：</label>
							<p>{{orderDetail.create_date}} <!-- <a>更多</a> --></p>
						</div>
                        <div class="order-info-item flex">
                            <label>订单备注：</label>
                            <p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
                        </div>
					</dd>
				</dl>
				

				<dl class="order-info">
					<dt>物流信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>收货人：</label>
							<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
						</div>
						<div class="order-info-item flex">
							<label>收货地址：</label>
							<p>{{orderDetail.receiving_address}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货时间：</label>
							<p>{{orderDetail.send_dates}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货物流：</label>
							<p>{{orderDetail.send_logistics_numbers}}</p>
						</div>
					</dd>
				</dl>
			</div>
		</module>
		
		<module>
			<div class="order-detail">
                <dt>采购商品</dt>
                <c-table v-model="productList" height="auto" :paging="false" border v-if="orderDetail">
                    <c-table-column
                        label="商品信息"
                        width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="规格名"
                        width="110"
                    >
                        <template v-slot="{data}">
                            {{data.product_sku_spec}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="商品SKU编码"
                        width="120"
                    >
                        <template v-slot="{data}">
                            {{data.product_sku_code?data.product_sku_code:'--'}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="采购单价"
                    >
                        <template v-slot="{data}">
                            ￥{{parseFloat(data.original_product_price).toFixed(2)}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="采购数量"
                        width="80"
                    >
                        <template v-slot="{data}">
                            ×{{data.product_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="小计"
                    >
                        <template v-slot="{data}">
                            ￥{{parseFloat(data.original_product_money).toFixed(2)}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="重量小计(克)"
                        width="100"
                    >
                        <template v-slot="{data}">
                            {{data.product_weight?data.product_weight:'--'}}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="已发货数"
                        width="80"
                    >
                        <template v-slot="{data}">
                            {{data.send_count}}
                        </template>
                    </c-table-column>
                </c-table>
				<div class="order-total flex-between-center">
					<div>采购总额 ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}</div>
				</div>
			</div>
		</module>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import {mapState} from 'vuex'
	export default {
		name: 'purchase_order_detail',
		
		components: {
			productInfo
		},
		
		props: {
			orderNumber: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo:'',
				invoiceInfo:'',
				invoiceDate:'',
				realityMoney: 0,
				sendList: [],
				editList: [],
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info:[],
				new_logistics_money: 0,
				old_money: 0,
                invoice_file_type:'',//开票文件类型
                invoice_file:'',//发票文件
                invoiceFileType:[{
                    name: '附件',
                    value: 1
                },{
                    name: '链接',
                    value: 2
                }],
                text_msg:'',
                reducedTypeName: {
                    0: '代理卡礼包',
                    1: '优惠券',
                    2: '限时折扣活动优惠',
                    3: '代理等级折扣',
                    4: '砍价活动优惠',
                    5: '抽奖奖品优惠',
                    6: '积分抵扣',
                    99: '订单调价'
                },
                express_list:[],//物流轨迹
                crtExpress: null,
                refundOrderList:[],
                returnOrderList:[],
                refundOrderStateName: {
                    1: '待审核',
                    2: '审核通过',
                    3: '已驳回',
                    4: '已撤销'
                },
                refundTypeName: {
                    1: '整单取消',
                    2: '未发退款',
                    3: '定金退款'
                },
                returnOrderStateName: {
                    1: '待审核',
                    2: '待会员退货',
                    3: '待财务打款',
                    5: '退款成功',
                    6: '已驳回',
                    8: '已撤销'
                },
                operationModeName: {
                    1: '平台自营',
                    2: '商家自营'
                }
            }
		},
		
		computed: {
			...mapState(['systemConfig']),
            orderState() {
                return {
                    2: '待发货',
                    3: '已' + this.orderDetail.deliver_state + (this.orderDetail.deliver_state=='全部发货' ? '，待确认收货':'，还有部分货品未发'),
                    5: '已确认收货',
                    6: '订单已取消'
                }[this.orderDetail.order_state];
            },
            orderStateWord() {
                var msg = "";
                if(this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2){
                    msg = "等待买家支付尾款";
                }else{
                    msg = {
                        2: '请尽快发货',
                        3: '',
                        5: '确认收货时间：' + this.orderDetail.confirm_date,
                        6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name:'') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）':'')
                    }[this.orderDetail.order_state];
                }
                return msg;
            }
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
            //获取订单详情数据
            getOrderDetail() {
                this.request({
                    url: '/purchase/order/detail',
                    data: {
                        order_number: this.orderNumber
                    },
                    loading: true,
                    success: data => {
                        this.orderDetail = data.base_info;
                        this.order_remark = this.orderDetail.order_remark;
                        this.productList = data.product_sku_info;
                        this.giftProductList = data.gift_product_list;
                        this.reducedList = data.reduced_list;
                        this.cusTomList = data.custom_list || [];
                        this.cusTomInfo = data.custom_info || {};
                        this.invoiceInfo = data.invoice_info;
                        this.pack_info = data.pack_info;
                        this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money || 0).toFixed(2) : (this.orderDetail.product_money + (this.cusTomInfo.product_price_money || 0) + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
                        this.refundOrderList = data.refund_order_list || [];
                        this.returnOrderList = data.return_order_list || [];
                    }
                });
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme'
	
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
			
			h1 {
				font-size: 24px;
			}
		}
		
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				p {
					a {
						color: #005CD9;
					}
				}
			}
		}
		
		&-detail {
			padding: 30px 30px 40px;
            dt {
                border-left: 3px solid #000;
                padding-left: 5px;
                margin-top: 25px;
                margin-bottom: 10px;
                line-height: 18px;
                font-size: 16px;
                font-weight: bold;
            }
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				theme-color(main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>